import { render, staticRenderFns } from "./order-list-item-create-softone-document-action.vue?vue&type=template&id=1ffdc7ae"
import script from "./order-list-item-create-softone-document-action.vue?vue&type=script&lang=js"
export * from "./order-list-item-create-softone-document-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports